<section class="addressSection">
  @if (addresses?.length >= 1 && !loading) {
    <mat-grid-list
      cols="3"
      rowHeight="1.5:1"
      class="gridSize"
      >
      @for (address of addresses; track address) {
        <mat-grid-tile
          [colspan]="1"
          [rowspan]="1"
          >
          <mat-card class="card">
            <p class="addressText">{{address.address.address1}}</p>
            <p class="addressText">{{address.address.address2}}</p>
            <p class="addressText">{{address.address.city}}</p>
            <p class="addressText">{{address.address.county}}</p>
            <p class="postcodeText">{{address.address.postCode}}</p>
            <p class="postcodeText">{{address.address.phone}}</p>
            <mat-card-actions align="end">
              <button mat-button (click)="deleteAccountConfirm(address)">
                <mat-icon>delete</mat-icon>DELETE
              </button>
            </mat-card-actions>
          </mat-card>
        </mat-grid-tile>
      }
    </mat-grid-list>
  }
  @if (addresses?.length < 1) {
    <p class="center">No Addresses to display</p>
  }
  <div class="center">
    @if (loading) {
      <mat-icon class="noAddressText loading">autorenew</mat-icon>
    }
  </div>
</section>
